import { Link } from "react-router-dom";
import { XCircle, Home } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div
      data-testid="payment-cancel-page"
      className="min-h-screen flex items-center justify-center bg-[#F4F1EA] p-6"
    >
      <div className="max-w-lg w-full bg-white border-2 border-[#0B1810] shadow-[10px_10px_0_#0B1810] p-8 md:p-10 text-center">
        <XCircle className="mx-auto text-[#0B1810]" size={64} />
        <h1 className="font-heading text-4xl md:text-5xl text-[#0B1810] mt-6">
          Payment Canceled
        </h1>
        <p className="mt-3 text-[#4A4D4A] font-body">
          No charge was made. You can try again whenever you're ready.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="cancel-home-button"
            className="btn-secondary justify-center"
          >
            <Home size={18} /> Back to Home
          </Link>
          <Link
            to="/#payment"
            data-testid="cancel-retry-button"
            className="btn-primary justify-center"
          >
            Try Again
          </Link>
        </div>
      </div>
    </div>
  );
}
